import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[rgba(152,191,162,0.15)] px-5 pb-10 pt-20 md:px-10">
    <div className="mx-auto max-w-[1400px]">
      <h2 className="font-display text-[18vw] font-900 uppercase leading-[0.8] tracking-tight md:text-[13vw]">
        Hybrid<span className="text-outline">Health</span>
      </h2>
      <div className="mt-12 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-end md:justify-between">
        <div data-testid="footer-legal" className="space-y-1 font-mono text-xs text-[#a3b1aa]">
          <p>Hybrid Health Lab</p>
          <p>Tutti i diritti riservati</p>
          <p>P.IVA: 07458790487</p>
        </div>
        <div className="flex flex-wrap gap-6">
          <Link to="/uso-etico-ia" data-testid="footer-ethical-ai-link" className="font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]">
            Uso etico dell'IA
          </Link>
          <Link to="/fonti" data-testid="footer-sources-link" className="font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]">
            Fonti scientifiche
          </Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]">
            Area riservata
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
